export interface ChecklistState {
  checklistTemplate: Array<any[]>;
  loader: boolean;
  shardchecklistTemplate: Array<any[]>;
  checklistItems?: any;
}

export const initialState: ChecklistState = {
  checklistTemplate: null,
  loader: false,
  shardchecklistTemplate: null,
  checklistItems: null,
};
